export {
  canOfferDesktopAppBridge,
  canOfferWebLocalWorkspaceCloudConversion,
  canShowUpstreamCommerce,
  canShowWorkspaceShareMenu,
  canUseGuestLocalWorkspace,
  FYDEOS_AI_PROVIDER_NAME,
  FYDEOS_NOTES_FEATURES,
  FYDEOS_NOTES_PRODUCT,
} from '@affine/env/brand';

export type FydeOSBrandLinks = {
  website: string;
  notesHome: string;
  help: string;
  feedback: string;
  community: string;
  updates: string;
  privacy: string;
  terms: string;
  upstreamSource: string;
  upstreamLicense: string;
  upstreamMitLicense: string;
  upstreamServerLicense: string;
  serverSource: string;
};

export const FYDEOS_NOTES_SYNC = 'FydeOS Notes Sync';

export const FYDEOS_NOTES_LOGO = {
  light: '/imgs/notes-text-logo.svg',
  dark: '/imgs/notes-text-logo-dark.svg',
};

export function getFydeOSBrandLinks(hostname: string): FydeOSBrandLinks {
  const normalizedHostname = hostname.toLowerCase().replace(/\.$/, '');
  const domain =
    normalizedHostname === 'notes.fydeos.io' ||
    normalizedHostname === 'notes.stag.fydeos.io'
      ? 'fydeos.io'
      : 'fydeos.com';
  const website = `https://${domain}`;

  return {
    website,
    notesHome: `https://notes.${domain}/`,
    help: `${website}/help/`,
    feedback: `https://community.${domain}`,
    community: `https://community.${domain}`,
    updates: `${website}/blog`,
    privacy: `${website}/privacy`,
    terms: `${website}/terms-of-service/`,
    upstreamSource: 'https://github.com/toeverything/AFFiNE',
    upstreamLicense:
      'https://github.com/toeverything/AFFiNE/blob/canary/LICENSE',
    upstreamMitLicense:
      'https://github.com/toeverything/AFFiNE/blob/canary/LICENSE-MIT',
    upstreamServerLicense:
      'https://github.com/toeverything/AFFiNE/blob/canary/packages/backend/server/LICENSE',
    serverSource: 'https://github.com/FydeOS/fydeos-notes-server',
  };
}

export function getCurrentFydeOSBrandLinks() {
  return getFydeOSBrandLinks(
    typeof window === 'undefined'
      ? 'notes.fydeos.com'
      : window.location.hostname
  );
}
